export default __webpack_public_path__ + "static/media/sonaanalyys_en.04287480.png";